import axios from "axios";
import { LocalStorageService } from "./LocalStorageService";
import { LoginService } from "./LoginService";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_ROUTE_API,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = new LocalStorageService().getAccessToken();
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
            config.headers["token"] = token; // Compatibilidad con Angular Legacy
            config.headers["api_token"] = token; // Compatibilidad con LoginService
        }
        if (!(config.data instanceof FormData)) {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (err) => {
        const originalConfig = err.config;

        if (err.response && err.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;

            try {
                const rs = await new LoginService().refreshToken();
                if (rs && rs.token) {
                    new LocalStorageService().setAccessRefreshRefresToken(rs);
                    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${rs.token}`;
                    axiosInstance.defaults.headers.common["token"] = rs.token;
                    return axiosInstance(originalConfig);
                }
            } catch (_error) {
                // Si el refresh token falla, cerrar sesión y redirigir al login
                new LocalStorageService().clearToken();
                window.location.href = "/login"; 
                return Promise.reject(_error);
            }
        }

        // Solo 401 invalida la sesión — un 400 es error de datos, no de autenticación
        if (err.response && err.response.status === 401) {
            new LocalStorageService().clearToken();
            window.location.href = "/login";
        }

        return Promise.reject(err);
    }
);

export default axiosInstance;
